import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import WinfieldsRoutes from './WinfieldRoutes';
import BecksRoutes from './BecksRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([WinfieldsRoutes, BecksRoutes, LoginRoutes]);
}
